const inputs = {  
    es: {
        fieldName: {
            label: "Nombre *",
            epmtyRule: "Por favor ingresa tu nombre",
        },
        fieldLastname: {
            label: "Apellido *",
            epmtyRule: "Por favor ingresa tu apellido",
        },
        fieldEmail: {
            label: "Email corporativo *",
            emptyRule: "Por favor ingresa tu Email",
            validRule: "Debe ser un Email corporativo"
        },
        fieldWebCorporative: {
            label: "Sitio web corporativo *",
            emptyRule: "Por favor ingresa el sitio web",
        },
        fieldCountry: {
            label: "Ubicación de la sede/país *",
            emptyRule: "Por favor selecciona una opción",
        },
        fieldSocial: {
            label: "¿Cómo te enteraste de nosotros? *",
            emptyRule: "Por favor selecciona una opción",
        },
        fieldTransactions: {
            label: "¿El volumen de transacciones excederá USD 250,000/mes? *",
            emptyRule: "Por favor selecciona una opción",
        },
        fieldIndustry: {
            label: "Sector en el que tienes licencia para operar *",
            emptyRule: "Por favor selecciona una opción",
        },
        fieldComments: {
            label: "¿Cómo puede PayRetailers ayudar a tu negocio?",
            emptyRule: "Por favor selecciona una opción",
        },
        fieldPrivacy: {
            label: "Acepto la política de privacidad *",
            emptyRule: "Debes aceptar la política de privacidad",
        },
    },
    en: {
        fieldName: {
            label: "Name *",
            epmtyRule: "Please enter your name",
        },
        fieldLastname: {
            label: "Last name *",
            epmtyRule: "Please enter your last name",
        },
        fieldEmail: {
            label: "Corporative Email *",
            emptyRule: "Please enter your email",
            validRule: "It must be a Corporative Email"
        },
        fieldWebCorporative: {
            label: "Corporative Website *",
            emptyRule: "Please enter your website",
        },
        fieldCountry: {
            label: "Country *",
            emptyRule: "Please select an option",
        },
        fieldSocial: {
            label: "How did you hear about us? *",
            emptyRule: "Please select an option",
        },
        fieldTransactions: {
            label: "Transaction volume with us to exceed USD 250,000/mo.? *",
            emptyRule: "Please select an option",
        },
        fieldIndustry: {
            label: "Industry Sector you have licence to operate *",
            emptyRule: "Please select an option",
        },
        fieldComments: {
            label: "How can PayRetailers assist your business?",
            emptyRule: "Please select an option",
        },
        fieldPrivacy: {
            label: "Accept privacy policy *",
            emptyRule: "You must accept privacy policy",
        },
    },
    pt: {
        fieldName: {
            label: "Nome",
            epmtyRule: "Por favor, insira seu nome",
        },
        fieldLastname: {
            label: "Sobrenome",
            epmtyRule: "Por favor, insira seu sobrenome",
        },
        fieldEmail: {
            label: "E-mail Corporativo *",
            emptyRule: "Por favor, insira seu e-mail",
            validRule: "Deve ser um e-mail corporativo",
        },
        fieldWebCorporative: {
            label: "Site Corporativo *",
            emptyRule: "Por favor, insira seu site",
        },
        fieldCountry: {
            label: "País *",
            emptyRule: "Por favor, selecione uma opção",
        },
        fieldSocial: {
            label: "Como nos conheceu? *",
            emptyRule: "Por favor, selecione uma opção",
        },
        fieldTransactions: {
            label: "Volume de transações conosco superior a USD 250.000/mês? *",
            emptyRule: "Por favor, selecione uma opção",
        },
        fieldIndustry: {
            label: "Setor da indústria em que você possui licença para operar *",
            emptyRule: "Por favor, selecione uma opção",
        },
        fieldComments: {
            label: "Como a PayRetailers pode ajudar o seu negócio?",
            emptyRule: "Por favor, selecione uma opção",
        },
        fieldPrivacy: {
            label: "Aceitar política de privacidade *",
            emptyRule: "Você deve aceitar a política de privacidade",
        },        
    }
}

const buttons = {
    es: {
        contact: "Contáctanos"
    },
    en: {
        contact: "Contact our team"
    },
    pt: {
        contact: "Fale conosco"
    }
}

export { inputs, buttons }